import HeaderV2 from './HeaderV2'

export default HeaderV2
// eslint-disable-next-line import/export
export * from './HeaderV2'
